import type * as FirebaseAuth from "firebase/auth"
import type { UserDocument } from "popopo-msg"
import { useForm } from "react-hook-form"
import { api } from "../../core"

export const UserProfileFriendCodeForm = (props: { firebase: FirebaseAuth.User; user: UserDocument }) => {
  const form = useForm({
    mode: "onBlur",
  })
  const { isSubmitting, isValid } = form.formState

  const onSubmit = async () => {
    try {
      const idToken = await props.firebase.getIdToken()
      await api.POST("/api/v2/users/me/profile/friend-code", {
        headers: {
          authorization: `Bearer ${idToken}`,
        },
      })
    } catch (e) {
      console.error(e)
    }
  }

  return (
    <form className="d-flex w-100 flex-column gap-3" onSubmit={form.handleSubmit(onSubmit)}>
      <button type="submit" className="btn btn-primary form-control" disabled={isSubmitting || !isValid}>
        Regenerate friend code
      </button>
    </form>
  )
}
